import React from "react";
import styled from 'styled-components';
import {
    Container, Row, Col,
} from 'react-bootstrap';
import './Banner-Style.css';
import '../../Style/typo.css';


const CheckIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle">
        <polyline points="13 17 18 12 13 7" stroke="#7061ff"></polyline>
        <polyline points="6 17 11 12 6 7" stroke="#7061ff"></polyline>
    </svg>
);


function BannerPrivateCloudENG() {

    return (
        <div class="banner">
            <Container className='main-body'>
                <Row>

                    <div class="banner-content-header">
                        <div class="text-description-header">
                            <p class="text-header typo-32 typo-medium typo-white">Private Kubernetes</p>
                        </div>
                        <div class="text-description typo-21 typo-white">
                            <p class="text-1">Build Kubernetes clusters on your own infrastructure without dependency on global clouds</p>
                        </div>
                    </div>
                    {/* <div class="banner-intro">
              <div class="banner-intro-text typo-14 typo-white">
                <p>복잡한 트래픽/리소스 기반 과금 모델, 예측 불가능한 클라우드 비용에 의존하지 않고 기업 내부 자원 위에 독립적인 Kubernetes 환경을 구성할 수 있습니다.</p>
                <p>클라우드 네이티브 인프라의 유연성을 유지하면서도, 비용 제어와 보안 통제가 필요한 환경에 최적화된 대안입니다.</p>
              </div>
            </div> */}
                    <div class="cloud-contact-intro private-banner-content">
                        <div class="cloud-contact-intro-text typo-14 purple-primary">
                            <div className='cloud-item-li private-banner-txt-line'>
                                <div className='cloud-item-icon'>
                                    <CheckIcon />
                                </div>
                                <div className='cloud-item-text'><p class="typo-16">An optimal solution for environments requiring cloud-native flexibility with cost control and security management.</p></div>
                            </div>
                            <div className='cloud-item-li private-banner-txt-line'>
                                <div className='cloud-item-icon'>
                                    <CheckIcon />
                                </div>
                                <div className='cloud-item-text txt-alignment'><p class="typo-16">Set up independent Kubernetes environments on internal resources, avoiding complex traffic/resource-based billing and unpredictable cloud costs.                                </p></div>
                            </div>
                        </div>
                        <div>
                            <button className="btn--default btn--primary">
                                <a className="url-btn" href="https://hanbiro.com/#/en/server-hosting-signup"><p class="typo-14">Register</p></a>
                            </button>
                        </div>
                    </div>
                </Row>
            </Container>
        </div>


    );
};

const TypographyCard = styled.div`
  color: white;
  
  h1, h2, h3, h4, h5, h6 {
    margin-bottom: 10px;
  }
`;


export default BannerPrivateCloudENG;



